var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatModelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93055 3.27705L4.54265 5.71305C4.20021 5.90395 3.91512 6.18306 3.717 6.52138C3.51888 6.85969 3.41496 7.24489 3.41602 7.63695V12.3631C3.41509 12.755 3.51907 13.14 3.71719 13.4782C3.9153 13.8164 4.20032 14.0954 4.54265 14.2862L8.93202 16.7229C9.25854 16.9046 9.62603 17 9.99971 17C10.3734 17 10.7409 16.9046 11.0674 16.7229L15.4568 14.2869C15.7992 14.096 16.0843 13.8169 16.2824 13.4786C16.4805 13.1403 16.5845 12.7551 16.5834 12.3631V7.63695C16.5843 7.24501 16.4803 6.85997 16.2822 6.52179C16.0841 6.18362 15.7991 5.90463 15.4568 5.71379L11.0674 3.27705C10.7409 3.09536 10.3734 3 9.99971 3C9.62603 3 9.25854 3.09536 8.93202 3.27705H8.93055Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.10526
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1371 6.3125L9.99922 9.99966M9.99922 9.99966L3.86133 6.3125M9.99922 9.99966V16.9923",
    stroke: "#F0F0F0",
    strokeWidth: 1.10526
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatModelIcon);
export default __webpack_public_path__ + "static/media/satModelIcon.5953fc3825f7cb3e5841a12c13177efa.svg";
export { ForwardRef as ReactComponent };